import React, { useState, useEffect } from 'react';
import { searchDemoDevices } from '../../apis/demo.api';
import DeviceTable from './components/DeviceTable';
import SearchBar from './components/SearchBar';
import AddDeviceButton from './components/AddDeviceButton';

const DemoManager = () => {
  const [demoDevices, setDemoDevices] = useState([]);

  const fetchDemoDevices = async () => {
    const devices = await searchDemoDevices();
    setDemoDevices(devices);
  };

  useEffect(() => {
    fetchDemoDevices();
  }, []);

  const handleSearch = async (params) => {
    const devices = await searchDemoDevices(params);
    console.log(devices);
    setDemoDevices(devices);
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <SearchBar onSearch={handleSearch} />
        <AddDeviceButton />
      </div>
      <DeviceTable demoDevices={demoDevices} />
    </div>
  );
};

export default DemoManager;

DemoManager.displayName = 'Demo Manager';
